import React from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { isAicopyBoomPopupRoute } from "@/components/Pages/aicopy/utils/boomPopup";

const AicopyBoomPopup = dynamic(() => import("../AicopyBoomPopup"), { ssr: false });
const AicopyBoomFollowBridge = dynamic(() => import("../AicopyBoomFollowBridge"), { ssr: false });

/** 仅在 /aicopy 首页挂载爆点弹窗 */
export default function AicopyBoomPopupGate() {
  const router = useRouter();
  if (!isAicopyBoomPopupRoute(router.pathname)) return null;
  return (
    <>
      <AicopyBoomPopup />
      <AicopyBoomFollowBridge />
    </>
  );
}
